module.exports = __webpack_public_path__ + "img/vue2-corpsarr_blanc.caf7feba.png";